var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmIdentityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.1723C20 18.1723 16.5 20.6723 12.34 22.1223C12.1222 22.1961 11.8855 22.1926 11.67 22.1123C7.5 20.6723 4 18.1723 4 13.1723V6.17232C4 5.90711 4.10536 5.65275 4.29289 5.46522C4.48043 5.27768 4.73478 5.17232 5 5.17232C7 5.17232 9.5 3.97232 11.24 2.45232C11.4519 2.27132 11.7214 2.17188 12 2.17188C12.2786 2.17188 12.5481 2.27132 12.76 2.45232C14.51 3.98232 17 5.17232 19 5.17232C19.2652 5.17232 19.5196 5.27768 19.7071 5.46522C19.8946 5.65275 20 5.90711 20 6.17232V13.1723Z",
    stroke: "url(#paint0_linear_28608_22301)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.1719V2.17188",
    stroke: "url(#paint1_linear_28608_22301)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28608_22301",
    x1: 12,
    y1: 2.17187,
    x2: 12,
    y2: 22.1752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D5E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28608_22301",
    x1: 12.5,
    y1: 2.17187,
    x2: 12.5,
    y2: 22.1719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D5E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIdentityIcon);
export default __webpack_public_path__ + "static/media/ConfirmIdentityIcon.08e2dca7d504d4233e7ed5c26be67728.svg";
export { ForwardRef as ReactComponent };